import { render, staticRenderFns } from "./user-card.vue?vue&type=template&id=bae7b196"
import script from "./user-card.vue?vue&type=script&lang=js"
export * from "./user-card.vue?vue&type=script&lang=js"
import style0 from "./user-card.vue?vue&type=style&index=0&id=bae7b196&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports